var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LhomeDialog"},[(_vm.type)?_c(_vm.comName,{tag:"component",attrs:{"type":_vm.type,"list":_vm.list},on:{"close":_vm.close}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }